import type { InterventionSectionCommentsProps } from "./intervention-section-comments.type";

import classNames from "classnames";

import { useScroll } from "@/hooks/useScroll";
import { useInterventionSectionContext } from "@/modules/intervention/intervention-section-context";
import ObservationCommentForm from "@/modules/observation/observation-comment-form";
import ObservationCommentsList from "@/modules/observation/observation-comments-list";

import { useInterventionSectionHideCommentsList } from "./intervention-section-comments.hook";

import "./intervention-section-comments.style.less";

const InterventionSectionComments = ({
  showTitle = false,
  className,
}: InterventionSectionCommentsProps) => {
  const { scrollableRef, scrollTo } = useScroll();
  const { observationId, observation, observationQuery } =
    useInterventionSectionContext();
  const hideCommentsList = useInterventionSectionHideCommentsList();
  const { isLoading } = observationQuery;

  // Check `observationId` instead of `observation?.id` to make sure
  // commponent stay mounted during observation fetch
  if (!observationId) return null;

  // Scroll back to top of div to see latest create comment
  const onSuccess = () => scrollTo({ top: 0 });

  return (
    <div
      className={classNames("intervention-section-comments", className)}
      ref={scrollableRef}
    >
      <ObservationCommentForm
        observation={observation}
        onSuccess={onSuccess}
        showTitle={showTitle}
        disabled={isLoading}
      />
      {!hideCommentsList && (
        <ObservationCommentsList
          observation={observation}
          loading={isLoading}
        />
      )}
    </div>
  );
};

export default InterventionSectionComments;
